import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import {STATIC_IMAGE, TICK_DOMAIN} from '../../../config/config';
import {useTranslation} from 'react-i18next';
import Card from './card/card';
import {OrderData} from '../suspendedConfirmation';

const MaybeSuccess = ({orderData}: {orderData: OrderData}) => {
    const {t} = useTranslation('suspendedConfirmation');

    return (
        <Card mainTitle={t('notConfirmed', {nameFirst: orderData.nameFirst})} subTitle={orderData.eventTitle} >
            <css.confirmationBoxFlexCenter>
                <css.rightBox>
                    <css.titleStart>
                        {t('thinking')}
                    </css.titleStart>
                    <css.boldText>
                        {t('thinkingDescription')}
                    </css.boldText>
                </css.rightBox>
                <css.image
                    src={`${STATIC_IMAGE}/app/ArrivalConfirmation/uncertain.png`}
                    alt=""   
                />
            </css.confirmationBoxFlexCenter>
                
            <css.buttonRow>
                <Btn href={TICK_DOMAIN} onClick={undefined} >{t('finish')}</Btn>
            </css.buttonRow>   
        </Card>
    );
};

export default MaybeSuccess;